<div class="container mt-5">
  @if (hasApiError) {
  <div class="alert alert-danger" role="alert">
    {{apiError}}
  </div>
  }

  @if (!material && !hasApiError) {
  <div class="text-center py-5 text-muted">Loading material...</div>
  }

  @if (material) {
  <div class="d-flex justify-content-between align-items-center mb-4">
    <div>
      <h2 class="mb-1">{{material?.name}}</h2>
      <div class="text-muted">{{material?.reference}}</div>
      <div class="small text-muted">ID: {{material?.id}}</div>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-4 mb-4 sidebar">

      @if (material?.key_words?.length) {
      <div class="card mb-3">
        <div class="card-header">Keywords</div>
        <div class="card-body d-flex flex-wrap gap-2">
          @for (kw of material?.key_words; track kw) {
          <span class="badge bg-primary">{{kw}}</span>
          }
        </div>
      </div>
      }

      <div class="card">
        <div class="card-header">Scalar properties</div>
        <div class="card-body p-0">
          <table class="table table-sm mb-0">
            <thead>
              <tr>
                <th>Name</th>
                <th class="text-end">Value</th>
                <th class="text-end">Unit</th>
              </tr>
            </thead>
            <tbody>
              @for (field of material?.data; track field.name) {
              @if (field.section == 'material_properties' && (!field.value.shape || field.value.shape[0] == 1)) {
              <tr>
                <td>{{field.name.replaceAll('_', ' ') | titlecase}}</td>
                <td class="text-end">{{field.value.magnitude[0]}}</td>
                <td class="text-end">{{field.value.unit_string || ''}}</td>
              </tr>
              }
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="col-lg-8 tabpanel">
      @if (chartData?.length && chartData[0]?.series?.length) {
      <div class="card mb-4">
        <div class="card-header">B-H curve</div>
        <div class="card-body">
          <div class="mb-3 text-muted">Magnetic flux density vs magnetic field strength</div>
          <ngx-charts-line-chart [scheme]="{ domain: ['#5AA454', '#A10A28', '#C7B42C', '#AAAAAA'] }"
            [results]="this.chartData" [gradient]="false" [xAxis]="true" [yAxis]="true" [legend]="true"
            [showXAxisLabel]="true" [showYAxisLabel]="true" [xAxisLabel]="'Magnetic Field Strength H (A/m)'"
            [yAxisLabel]="'Magnetic Flux Density B (T)'" [autoScale]="true">
          </ngx-charts-line-chart>
        </div>
      </div>
      }

      <div class="card">
        <div class="card-header">Raw data</div>
        <div class="card-body">
          <pre class="mb-0"><code class="js rounded">{{materialJson}}</code></pre>
        </div>
      </div>
    </div>
  </div>
  }
</div>